import { useMxFieldControllerContext } from "../../../../context/MxFieldController";
import MxTextAreaField, {
  IMxTextAreaFieldProps
} from "@rf-l1/form/text-fields/MxTextAreaField";

export type IMxFormTextAreaFieldProps = IMxTextAreaFieldProps
const MxFormTextAreaField = (props: IMxFormTextAreaFieldProps) => {
  const { onChange, onBlur, name, value, invalid, id, inputRef } =
    useMxFieldControllerContext();
  return (
    <MxTextAreaField
      {...props}
      id={id}
      error={invalid}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      name={name}
    />
  );
};

export default MxFormTextAreaField;
